import React from "react";
import { ArrowRight } from "lucide-react";

export default function CollectiveComplaint() {
  return (
    <section className="bg-gradient-to-r from-[#fdf3e8] to-[#fef9ee] border-b border-gray-200">
      <div className="max-w-[1200px] mx-auto px-4 py-6">
        <h2 className="text-lg md:text-2xl font-bold text-gray-900 mb-4">
          Turn one complaint into a collective action
        </h2>
        <div className="flex flex-col md:flex-row gap-5 items-start">
          <div className="shrink-0 w-full md:w-[320px] aspect-[3/2] rounded-lg overflow-hidden bg-[#fdf3e8] border border-[#f5a623]/20 max-h-[240px] md:max-h-none">
            <img
              src="/collective.png"
              alt="A diverse group of UK consumers joining together to raise a collective complaint"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex-1">
            <p className="text-sm text-gray-700 leading-relaxed">
              A Collective Complaint helps you unite consumers dealing with the same issue, such as wrong charges,
              unexpected fees, damaged items, or misleading promises. It goes beyond a single review by growing
              stronger with every signature, making it harder to ignore. Once you reach 20 supporters, we'll send it
              to the company to encourage a response.
            </p>
            <button className="mt-4 inline-flex items-center gap-2 bg-[#e84e1c] hover:bg-[#d04515] transition-colors text-white font-semibold text-sm px-5 py-2.5 rounded-md">
              Start Collective Complaint <ArrowRight size={16}/>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
